module.exports = __webpack_public_path__ + "img/amor-face-4.772de2a0.jpg";